import { render, staticRenderFns } from "./HomeNavigation.vue?vue&type=template&id=22522850"
import script from "./HomeNavigation.vue?vue&type=script&lang=js"
export * from "./HomeNavigation.vue?vue&type=script&lang=js"
import style0 from "./HomeNavigation.vue?vue&type=style&index=0&id=22522850&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports